module.exports = __webpack_public_path__ + "img/user.c01cd589.png";